
import ErrorBoundary from '../Components/ErrorBoundary/ErrorBoundary';

const withErrorBoundary: (
  name: string
) => <T>(
  Component: React.ComponentType<React.PropsWithChildren<T>>
) => React.ComponentType<React.PropsWithChildren<T>> =
  name => Component => props =>
    (
      <ErrorBoundary name={name}>
        <Component {...props} />
      </ErrorBoundary>
    );

export default withErrorBoundary;
